<template>

  <v-dialog v-if="missionAsset" dark persistent v-model="show" width="500">

    <v-card>

      <v-card-title>
        <v-row>
          <v-col cols="8">Inspection #{{ missionAsset.id }}</v-col>
          <v-col cols="4">
            <div class="text-end">
                <v-btn color="light" text @click.stop="onCloseDialogIntent" :disabled="loading">Close</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>

        <v-card v-if="confirming_delete" light>
            <v-card-text>
                <div class="text-center">
                  Are you sure you want to delete this inspection?
                  <br>
                  This action cannot be undone.
                  <div class="mt-3">
                      <v-container>
                          <v-row>
                              <v-col cols="5">
                                  <v-btn x-large block color="light" @click="onDeclineDelete" :disabled="loading">CANCEL</v-btn>
                              </v-col>
                              <v-col cols="2">
                              </v-col>
                              <v-col cols="5">
                                  <v-btn x-large block color="red" @click="onConfirmDelete" :disabled="loading" :loading="loading">CONFIRM</v-btn>
                              </v-col>
                          </v-row>
                      </v-container>
                  </div>
                </div>
            </v-card-text>
        </v-card>

        <v-list v-else dense>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Mission</v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-subtitle>
                {{ missionAsset.missionId }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Date</v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-subtitle>
                {{ missionAsset.createdAt | dateLocal("DD-MMM-YYYY") | toUpperCase }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ getTerminology('mission_assets.third_party_code') || 'Third Party Code' }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-subtitle>
                <span v-if="missionAsset.thirdPartyCode">{{ missionAsset.thirdPartyCode }}</span>
                <v-tooltip v-else top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ missionAsset.id }}
                      <v-icon color="orange">mdi-alert-circle</v-icon>
                    </span>
                  </template>
                  External asset data unavailable
                </v-tooltip>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Result</v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-subtitle>
                <v-chip v-if="missionAsset.passFail == 'pass'" label small color="green">{{ getTerminology("pass") || "Pass" }}</v-chip>
                <v-chip v-if="missionAsset.passFail == 'fail'" label small color="red">{{ getTerminology("fail") || "Fail" }}</v-chip>
                <v-chip v-if="missionAsset.isFault" label small color="orange" class="ml-2">Fault</v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="missionAssetComment">
            <v-list-item-content>
              <v-textarea light solo dense readonly rows="3" :hide-details="true" :value="missionAssetComment.content"></v-textarea>
              <!--
              <v-btn small color="primary" @click="onCopyCommentIntent(missionAssetComment.id)">
                <v-icon small>mdi-content-copy</v-icon>
                Copy
              </v-btn>
              -->
            </v-list-item-content>
          </v-list-item>
        </v-list>

      </v-card-text>

      <v-divider></v-divider>

        <v-card-actions>
            <v-container>
                <v-row>
                    <v-col cols="6">
                        <v-btn x-large block color="orange" @click.stop="onDeleteIntent(true)" :disabled="loading || confirming_delete">DELETE & REDO</v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn x-large block color="red" @click.stop="onDeleteIntent(false)" :disabled="loading || confirming_delete">DELETE</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-actions>

    </v-card>

  </v-dialog>

</template>

<script>
import { mapGetters } from "vuex";
import { denormalize } from "@/helpers/JsonApiDenormalizer";
import { MissionAssetService } from "@/services/missionAsset.service";

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    missionAsset: {
      type: Object,
      required: false,
    },
  },
  data: () => ({
    loading: false,
    asset_id_redo: null,
    confirming_delete: false,
    mission_asset_comments: [],
  }),
  computed: {
    ...mapGetters("config", ["getTerminology"]),
    missionAssetComment() {
      let comment = null;
      if (this.mission_asset_comments.length > 0) {
        comment = Object.assign({}, this.mission_asset_comments.slice(0, 1).shift());
      }
      return comment;
    }
  },
  created() {
    //
  },
  mounted() {
    //
  },
  watch: {
    "missionAsset.id": function(mission_asset_id) {
      if ( ! mission_asset_id) {
        this.mission_asset_comments = [];
      }
      else {
        this.getMissionAssetData(mission_asset_id).then(res => {
          const ma = denormalize(res.data);
          this.mission_asset_comments = ma.comments || [];
        })
        .catch(err => {
          this.$store.commit("snacktime", {
            text: "Failed to fetch some remote data.",
            color: "error",
          });
        });
      }
    }
  },
  methods: {
    async getMissionAssetData(mission_asset_id) {
      return await MissionAssetService.find(mission_asset_id, { include: 'comments' });
    },
    onCloseDialogIntent() {
      this.asset_id_redo = null;
      this.confirming_delete = false;
      this.$emit('update:show', false);
    },
    onDeleteIntent(redo) {
      this.asset_id_redo = redo ? this.missionAsset.coreId : null;
      this.confirming_delete = true;
    },
    onConfirmDelete() {
      this.loading = true;
      MissionAssetService.delete(this.missionAsset.id).then(res => {
        let missionAssetSnapshot = Object.assign({}, this.missionAsset);
        this.$emit('mission-asset-deleted', {
          missionAsset: missionAssetSnapshot,
          redo: this.asset_id_redo ? true : false,
        });
        this.$nextTick(() => {
          this.onCloseDialogIntent();
        });
      })
      .catch(err => {
        this.$store.commit("snacktime", {
          text: "Failed to delete the data.",
          color: "error",
        });
      })
      .finally(() => {
        this.loading = false;
      })
    },
    onDeclineDelete() {
      this.confirming_delete = false;
    },
    onCopyCommentIntent(comment_id) {
      const comment = this.mission_asset_comments.find(c => {
        return c.id == comment_id;
      });
      if (comment) {
        const vm = this;
        navigator.clipboard.writeText(comment.content).then(function() {
          vm.$store.commit("snacktime", {
            text: "Text copied to clipboard.",
            color: "success",
          });
        })
        .catch(() => {
          vm.$store.commit("snacktime", {
            text: "Failed to copy text to clipboard.",
            color: "error",
          });
        });
      }
    }
  }
};
</script>

<style lang="scss"></style>
